import React from 'react';
import { Check, Plus } from 'lucide-react';
export function ValueStackBox() {
  const items = [{
    name: 'MegaPack Biología Lista™ (Acceso de por vida)',
    price: 199
  }, {
    name: 'Bono 1: Biología Experimental',
    price: 29
  }, {
    name: 'Bono 2: Kit de Evaluaciones',
    price: 29
  }, {
    name: 'Bono 3: Material Didáctico Extra',
    price: 29
  }, {
    name: 'Bono 4: Planillas de Organización',
    price: 29
  }];
  const totalValue = items.reduce((acc, item) => acc + item.price, 0);
  return <div className="bg-white border-2 border-dashed border-emerald-200 rounded-xl p-6 mb-8 max-w-md mx-auto" data-id="element-131">
      <h3 className="text-center font-bold text-gray-900 mb-4 uppercase tracking-wide text-sm" data-id="element-132">
        Lo que recibes hoy:
      </h3>

      <div className="space-y-3 mb-6" data-id="element-133">
        {items.map((item, idx) => <div key={idx} className="flex justify-between items-center text-sm border-b border-gray-100 pb-2 last:border-0" data-id="element-134">
            <div className="flex items-start gap-2 text-left" data-id="element-135">
              <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-136" />
              <span className="text-gray-700" data-id="element-137">{item.name}</span>
            </div>
            <span className="font-bold text-gray-400 line-through ml-2 whitespace-nowrap" data-id="element-138">
              ${item.price}
            </span>
          </div>)}
      </div>

      <div className="bg-gray-50 p-4 rounded-lg flex justify-between items-center border border-gray-200" data-id="element-139">
        <span className="font-bold text-gray-700" data-id="element-140">VALOR TOTAL REAL:</span>
        <span className="font-black text-xl text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-141">
          ${totalValue} USD
        </span>
      </div>

      <div className="mt-4 text-center" data-id="element-142">
        <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse mb-2" data-id="element-143">
          AHORRAS 96% HOY
        </div>
        <p className="text-xs text-gray-500" data-id="element-144">
          El precio subirá a $49.99 en cuanto termine el contador.
        </p>
      </div>
    </div>;
}